import "./base";
import "./inputFilter";
import pym from "pym.js";

var VALeadForm = (function() {
  var $mVethubLeadForm = null;
  var $mVethubLeadFormWrapper = null;
  var overlayMode = false;
  var leadFormSrc = 'VA';
  var alternativePhone = '';

  var showErrorMsg = function(placeHolder, msg) {
    placeHolder.find("#locationErrorMsg").show().text(msg);
    placeHolder.find(".hf-error").show();
  };

  var hideErrorMsg = function(placeHolder) {
    placeHolder.find("#locationErrorMsg").hide().text('');
    placeHolder.find(".input-error").removeClass('input-error');
    placeHolder.find(".hf-error").hide();
  };

  var setFocusOnErrorCtrl = function(ctrl) {
    ctrl.addClass('input-error');
    setTimeout(function() {
      ctrl.focus();
    }, 5);
  };

  var loanPurposeValidate = function() {
    var purpose = $mVethubLeadForm.find('#loanType').val().trim();
    if (purpose.length === 0) {
      $mVethubLeadForm.find('#loanType').addClass('select-error');
    } else {
      $mVethubLeadForm.find('#loanType').removeClass('select-error');
    }
  };

  var credirScoreValidate = function() {
    var creditScore = $mVethubLeadForm.find('#creditScore').val().trim();
    if (creditScore.length === 0) {
      $mVethubLeadForm.find('#creditScore').addClass('select-error');
    } else {
      $mVethubLeadForm.find('#creditScore').removeClass('select-error');
    }
  };

  //***** VA Lead Form
  var doVALeadFormSubmit = function (loan_type, loan_price, loan_state, credit_score, last_name, first_name, email, street, zip_code, phone, source, lead_form) {
    var leadPostUrl = $("#VA_Lead_Form").data('action');
    var authenticity_token = $('#authenticity_token').val();

    $.ajax({
        type: 'POST',
        url: leadPostUrl,
        data: {
          authenticity_token: authenticity_token, loan_type: loan_type, loan_price: loan_price, loan_state: loan_state,
          credit_score: credit_score, last_name: last_name, first_name: first_name, email: email,
          street: street, zip_code: zip_code, phone: phone, source: source, lead_form: lead_form
        },
        success: function (vu_lead) {
          try {
            var data = jQuery.parseJSON(vu_lead.veteran_lead_data);
            if (data.submit && data.submit.indexOf("Success: 1 Leads Sent") >= 0) {
              displayLeadSuccess();
            }
            else if (data.submit && data.submit.indexOf("No Leads Sent") >= 0) {
              displayNoLead();
            }
            else if (data.email && data.email.length >= 0) {
              $mVethubLeadForm.find('#email').addClass('input-error');
            }
            else if (data.phone && data.phone.length >= 0) {
              $mVethubLeadForm.find('#phone').addClass('input-error');
            }
            else {
              displayLeadFail();
            }
          }
          catch(err) {
            displayLeadFail();
          }
          resetVALeadSubmit();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          displayLeadFail();
          resetVALeadSubmit();
        }
    });
  };

  var displayNoLead = function() {
    $('#VAnoleadModal').find('a.Failed').hide();
    $('#VAnoleadModal').find('a.BackToForm').show();
    if (!overlayMode) {
      $mVethubLeadForm.hide();
    }
    $('#VAnoleadModal').show();
  };

  var displayLeadSuccess = function() {
    if (alternativePhone !== '') {
      $('#VAleadthankyouModal').find('p.cta span').text(alternativePhone);
    }

    $('#VAleadthankyouModal').find('a.ThankYou').hide();
    $('#VAleadthankyouModal').find('a.BackToForm').show();
    if (!overlayMode) {
      $mVethubLeadForm.hide();
    }
    $('#VAleadthankyouModal').show();

    if (leadFormSrc == 'VAGuide') {
      var axel = Math.random() + "";
      var a = axel * 10000000000000;
      var url = 'https://3967255.fls.doubleclick.net/activityi;src=3967255;type=realt0;cat=realt0;ord=1;num=' + a + '?';
      (new Image()).src = url;
      try {
        vaguide_lead_form_track('vaguide');
      } catch (e) {}
    }
  };

  var displayLeadFail = function() {
    if (alternativePhone !== '') {
      $('#VAleadfailedModal').find('p.cta span').text(alternativePhone);
    }

    $('#VAleadfailedModal').find('a.Failed').hide();
    $('#VAleadfailedModal').find('a.BackToForm').show();
    if (!overlayMode) {
      $mVethubLeadForm.hide();
    }
    $('#VAleadfailedModal').show();

  };

  var loanStateValidate = function() {
    var state = $mVethubLeadForm.find('#loanState').val().trim();
    if (state.length === 0) {
      $mVethubLeadForm.find('#loanState').addClass('select-error');
    } else {
      $mVethubLeadForm.find('#loanState').removeClass('select-error');
    }
  };

  var priceValidate = function() {
    var price = parseInt($mVethubLeadForm.find('#loan_price').val().replace('$', '').replace(/,/g, ''));
    if (isNaN(price)) {
      $mVethubLeadForm.find('#loan_price').addClass('input-error');
      return;
    };

    if (price > 99999999)
      price = 99999999;

    if (price < 2000)
      price = 2000;

    $mVethubLeadForm.find('#loan_price').removeClass('input-error');
    $mVethubLeadForm.find('#loan_price').val(addCommas(price));

    showFirstError();
  };

  var fullnameValidate = function() {
    var fullname = $mVethubLeadForm.find('#fullname').val().trim();
    if (fullname.split(" ").length < 2) {
      $mVethubLeadForm.find('#fullname').addClass('input-error');
    } else {
      $mVethubLeadForm.find('#fullname').removeClass('input-error');
    }

    showFirstError();
  };

  var addressValidate = function() {

    var address = $mVethubLeadForm.find('#address').val().trim();
    if (address.length === 0) {
      $mVethubLeadForm.find('#address').addClass('input-error');
    } else {
      $mVethubLeadForm.find('#address').removeClass('input-error');
    }

    showFirstError();
  };

  var emailValidate = function() {

    var regex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    var email = $mVethubLeadForm.find('#email').val().trim();

    if (!regex.test(email)) {
      $mVethubLeadForm.find('#email').addClass('input-error');
    } else {
      $mVethubLeadForm.find('#email').removeClass('input-error');
    }

    showFirstError();
  };

  var zipcodeValidate = function() {

    var zipcode = $mVethubLeadForm.find('#zipcode').val().trim();
    if (zipcode.length != 5) {
      $mVethubLeadForm.find('#zipcode').addClass('input-error');
    } else {
      $mVethubLeadForm.find('#zipcode').removeClass('input-error');
    }

    showFirstError();
  };

  var phoneValidate = function() {

    var phoneNum = $mVethubLeadForm.find('#phone').val().trim();
    if (phoneNum.length != 10) {
      $mVethubLeadForm.find('#phone').addClass('input-error');
    } else {
      $mVethubLeadForm.find('#phone').removeClass('input-error');
    }

    showFirstError();
  };

  var showFirstError = function() {
    $mVethubLeadForm.find(".hf-error").hide();
    $mVethubLeadForm.find(".input-error:first").parent().parent().find("label").show();
  };

  var validateAll = function() {
    loanPurposeValidate();
    priceValidate();
    loanStateValidate();
    credirScoreValidate();

    fullnameValidate();
    emailValidate();
    addressValidate();
    zipcodeValidate();
    phoneValidate();

    showFirstError();
  };
  var resetVALeadSubmit = function () {
    $mVethubLeadForm.find("#SubmitLeadform").val("What Am I Eligible For?");
    $mVethubLeadForm.find("#SubmitLeadform").removeAttr('disabled');
  };

  var callLeadSumbit = function() {
    validateAll();

    var validationPassed = ($mVethubLeadForm.find(".input-error").length + $mVethubLeadForm.find(".select-error").length) == 0;

    if (validationPassed) {
      var loan_type = $mVethubLeadForm.find("#loanType").val().trim();
      var loan_price = $mVethubLeadForm.find("#loan_price").val().replace('$', '').replace(/,/g, '');
      var loan_state = $mVethubLeadForm.find("#loanState").val().trim();
      var credit_score = $mVethubLeadForm.find("#creditScore").val().trim();

      var full_name = $mVethubLeadForm.find("#fullname").val().trim();
      var email = $mVethubLeadForm.find("#email").val().trim();
      var street = $mVethubLeadForm.find("#address").val().trim();
      var zip_code = $mVethubLeadForm.find("#zipcode").val().trim();
      var phone = $mVethubLeadForm.find("#phone").val().trim();

      var name = full_name.split(" ");
      var last_name = name[name.length - 1].trim();
      var first_name = full_name.replace(last_name, "").trim();
      var source = leadFormSrc;
      var lead_form = 'VAGuide';

      omnitureLeadformSubmitEvent();

      $mVethubLeadForm.find("#SubmitLeadform").attr('disabled', 'disabled');
      $mVethubLeadForm.find("#SubmitLeadform").val("Processing ... ");
      doVALeadFormSubmit(loan_type, loan_price, loan_state, credit_score, last_name, first_name, email, street, zip_code, phone, source, lead_form)
    }
  };

  var omnitureLeadformSubmitEvent = function() {
    try {
      if ((leadFormSrc != 'VAGuide') && (s)) {
        s.eVar42 = "leads:lender:veteransHub";
        s.eVar55 = "(" + $mVethubLeadForm.find("#creditScore").val().trim() + ")";
        s.events = "event27";
        s.channel = "finance";
        s.tl();
      }
    } catch (e) {}
  };

  var bindLeadFormControls = function() {
    $(".ThankYou")
      .on("click", function() {
        $('#VAleadthankyouModal').hide();
      });

    $(".Failed")
      .on("click", function() {
        $('#VAleadfailedModal').hide();
        $('#VAnoleadModal').hide();
      });

    $(".BackToForm").on("click", function() {
      $('#VAleadthankyouModal').hide();
      $('#VAleadfailedModal').hide();
      $('#VAnoleadModal').hide();
      $mVethubLeadForm.show();
    });

    $mVethubLeadForm.find("#loanType")
      .on("change", loanPurposeValidate);

    $mVethubLeadForm.find("#loanState")
      .on("change", loanStateValidate);

    $mVethubLeadForm.find("#creditScore")
      .on("change", credirScoreValidate);

    $mVethubLeadForm.find("#loan_price")
      .on("keypress", restrictNumbersOnly)
      .on("change", priceValidate);

    $mVethubLeadForm.find("#fullname")
      .on("change", fullnameValidate);

    $mVethubLeadForm.find("#email")
      .on("change", emailValidate);

    $mVethubLeadForm.find("#address")
      .on("change", addressValidate);

    $mVethubLeadForm.find("#zipcode")
      .on("keypress", restrictNumbersOnly)
      .on("change", zipcodeValidate);

    $mVethubLeadForm.find("#phone")
      .on("keypress", restrictNumbersOnly)
      .on("change", phoneValidate);

    $mVethubLeadForm.find("#SubmitLeadform")
      .on("click", function() {

        callLeadSumbit();
      });
  };

  var init = function() {
    $mVethubLeadForm = $("#VA_Lead_Form");
    bindLeadFormControls();
  };

  var setOverlayMode = function(mode) {
    overlayMode = mode;
  };

  var setLeadFormSrc = function(src) {
    leadFormSrc = src;
  };

  var setAlternativePhone = function(phone) {
    alternativePhone = phone;
  };

  VALeadForm = {
    init: init,
    setOverlayMode: setOverlayMode,
    setLeadFormSrc: setLeadFormSrc,
    setAlternativePhone: setAlternativePhone
  };

  return VALeadForm;

})(VALeadForm || {});

$(window).load(function() {
  VALeadForm.init();
  // From VAGuide
  VALeadForm.setOverlayMode(true);
  var source_para = getParameterByNameFromQuery("source") || getParameterByName("source");
  if (source_para) {
    VALeadForm.setLeadFormSrc(source_para);
  }
  else {
    VALeadForm.setLeadFormSrc('VAGuide');
  }
  VALeadForm.setAlternativePhone('1-844-488-8229');

  // Handle iframe resize with pym.js
  // bypassing usual cross-domain issues
  // http://blog.apps.npr.org/pym.js/
  var pymChild = new pym.Child();
});



// WEBPACK FOOTER //
// ./mortgage/v7/va_lead_widget.js